<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div
              class="card-header card-header-primary negative blue-grad w-50"
            >
              <h4 class="card-title">
                {{ $t("message.menu.comply_advantage") }}
              </h4>
            </div>

            <div class="card-body px-3">
              <b-tabs pills content-class="mt-3" small v-model="current_tab">
                <b-tab
                  :title="$t('message.comply_advantage.search_tab')"
                  active
                  id="search-tab"
                >
                  <comply-advantage-search></comply-advantage-search>
                </b-tab>
                <b-tab
                  :title="$t('message.comply_advantage.case_management_tab')"
                  lazy
                  id="case-management-tab"
                >
                  <comply-advantage-case-management></comply-advantage-case-management>
                </b-tab>
              </b-tabs>
            </div>
          </div>
          <ca-footer-docs v-if="locale == 'ru-RU'" />
          <ca-footer-docs-en v-if="locale == 'en-US'" />
          <!-- <div class="py-5">
						<h3>Мониторинг и проверки контрагентов</h3>
						<p style="margin-bottom: 0;">Проверь своего контрагента!  Система предоставляет мгновенный доступ:</p>
						<ul style="margin-bottom: 0">
							<li>к актуальной информации <strong>санкционных списков</strong> (более 150 списков большинства стран)</li>
							<li>к спискам неблагонадежных компаний и физических лиц (более 160 списков, в том числе отчеты кредитных бюро, комиссий по ценным бумагам, бирж и иных организаций по большинству стран) </li>
							<li>к предупреждающим спискам, выпускаемых государственными организациями большинства стран (более 1140 списков) </li>
							<li>к спискам политически значимых лиц (более 2 миллионов человек), </li>
							<li>к негативной информации в открытых источниках по темам связанным с преступлениями, на которые необходимо обратить внимание при проверке контрагента</li>
						</ul>
						<p style="margin-bottom: 0;">Сервис дает Вам возможность сохранять полученные сведения в файл <strong>pdf-формата</strong> с отображением даты и времени формирования документа.</p>
						<p style="margin-bottom: 0;">Сервис производит автоматическую тарификацию предоставления результатов, с контролем достаточности денежных средств на Вашем системном счете. Перед выполнением каждого запроса Сервис выводит на экран стоимость услуги и предлагает Вам подтвердить свое <strong>согласие</strong> на ее оплату.</p>
						<p style="margin-bottom: 0;">В стоимость услуги входит <strong>бесплатный мониторинг</strong> изменений данных запроса в течение 12 месяцев.</p>
						<br>
						<h3>Как получить</h3>
						<p>Для поиска Вам необходимо ввести <strong>наименование</strong> (или фрагмент наименования) <strong>юридического лица</strong> либо имя физического лица на английском или русском языках.</p>
						<p><strong>Все результаты поиска сохраняются в истории</strong>. Вы можете получить доступ к сохраненным результатам, как для повторного просмотра, так и для вывода на печать.</p>
						<p>Здесь Вы сможете настроить <strong>бесплатный мониторинг</strong> по сформированному запросу. Что позволит Вам автоматически отслеживать изменения информации проверяемого объекта, и получать соответствующие уведомления об изменениях в Ваш личный кабинет.</p>
					</div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      current_tab: 0,
    };
  },
  computed: {
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
        case "ru":
          locale = "ru-RU";
          break;
      }
      return locale;
    },
  },
  mounted() {
    if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
    this.$root.$on("open_ca_search_tab", (data) => {
      this.current_tab = 0;
      console.log("atejo open_ca_search_tab");
      setTimeout(() => {
        this.$root.$emit("go_to_ca_search", data);
      }, 500);

      //}, 1000)
    });
    if (this.$route.name == "comply-advantage-history") {
      this.current_tab = 1;
    }
    if (this.$route.name == "ca-single") {
      this.current_tab = 1;

      setTimeout(() => {
        this.$root.$emit("open_ca_search_tab", this.$route.params.data);
      }, 100);
    }
  },
};
</script>
<style>
.columns {
  align-items: stretch;
  padding-bottom: 20px;
}
.columns .card {
  background-color: #fff !important;
  height: 100%;
}
.columns .card .icon {
  height: 44px;
  width: 44px;
  border-radius: 44px;
  background-color: #f9faf9 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}
.columns .card .title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  display: flex;
  align-items: center;
  letter-spacing: 0.1px;

  /* neutral/10 */

  color: #333333;
}
.columns .card .card-body p {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* or 143% */

  display: flex;
  align-items: center;
  letter-spacing: 0.25px;

  /* neutral/30 */

  color: #797980;
}
</style>
